var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryTruck5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18C19 19.1046 18.1046 20 17 20C15.8954 20 15 19.1046 15 18C15 16.8954 15.8954 16 17 16C18.1046 16 19 16.8954 19 18Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6C2 4.89543 2.89543 4 4 4H16.8949C17.5826 4 18.2221 4.35338 18.5881 4.93566L21.6933 9.87566C21.8937 10.1945 22 10.5634 22 10.94V11.25H15V12.75H22V16C22 16.9321 21.3623 17.7153 20.4994 17.9371C20.4659 16.0331 18.912 14.5 17 14.5C15.067 14.5 13.5 16.067 13.5 18H10.5C10.5 16.067 8.933 14.5 7 14.5C5.088 14.5 3.53409 16.0331 3.50056 17.9371C2.63766 17.7153 2 16.9321 2 16V6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryTruck5);
export default __webpack_public_path__ + "static/media/delivery-truck-5.b1d3adc34b0f26a49865dff9f62356ac.svg";
export { ForwardRef as ReactComponent };